// Config for each product category — drives dynamic form + table columns.
export const CATEGORY_OPTIONS = [
  { value: 'Mobile Phone', label: 'Mobile Phone', prefix: 'MB' },
  { value: 'Home Appliance', label: 'Home Appliance', prefix: 'HA' },
  { value: 'Motorcycle', label: 'Motorcycle', prefix: 'MC' },
  { value: 'Car', label: 'Car', prefix: 'CR' },
  { value: 'Property', label: 'Property', prefix: 'PR' },
];

export const APPLIANCE_CATEGORIES = [
  'LED TV', 'Refrigerator', 'Air Conditioner', 'Washing Machine',
  'Deep Freezer', 'Microwave', 'Water Dispenser', 'Geyser', 'Fan', 'Iron', 'Other'
];

export const PROPERTY_TYPES = ['Plot', 'House', 'Flat', 'Apartment', 'Shop', 'Office', 'Commercial'];

export const STOCK_STATUS = ['Available', 'Reserved', 'Booked', 'Sold', 'Returned'];

// Field spec — { key, label, type, required?, options? }
// type: text | number | date | select | textarea
export const CATEGORY_FIELDS = {
  'Mobile Phone': [
    { key: 'brand', label: 'Brand', type: 'text', required: true },
    { key: 'model', label: 'Model', type: 'text', required: true },
    { key: 'variant', label: 'Variant', type: 'text' },
    { key: 'color', label: 'Color', type: 'text' },
    { key: 'storage', label: 'Storage', type: 'text' },
    { key: 'imei', label: 'IMEI 1', type: 'text', unique: true },
    { key: 'imei2', label: 'IMEI 2', type: 'text', unique: true },
    { key: 'serial_number', label: 'Serial Number', type: 'text', unique: true },
  ],
  'Home Appliance': [
    { key: 'appliance_category', label: 'Category', type: 'select', options: APPLIANCE_CATEGORIES, required: true },
    { key: 'brand', label: 'Brand', type: 'text', required: true },
    { key: 'model', label: 'Model', type: 'text', required: true },
    { key: 'serial_number', label: 'Serial Number', type: 'text', required: true, unique: true },
  ],
  'Motorcycle': [
    { key: 'brand', label: 'Brand', type: 'text', required: true },
    { key: 'model', label: 'Model', type: 'text', required: true },
    { key: 'model_year', label: 'Model Year', type: 'number' },
    { key: 'color', label: 'Color', type: 'text' },
    { key: 'engine_number', label: 'Engine Number', type: 'text', required: true, unique: true },
    { key: 'chassis_number', label: 'Chassis Number', type: 'text', required: true, unique: true },
    { key: 'registration_number', label: 'Registration Number', type: 'text', unique: true },
  ],
  'Car': [
    { key: 'brand', label: 'Brand', type: 'text', required: true },
    { key: 'model', label: 'Model', type: 'text', required: true },
    { key: 'variant', label: 'Variant', type: 'text' },
    { key: 'model_year', label: 'Model Year', type: 'number' },
    { key: 'color', label: 'Color', type: 'text' },
    { key: 'engine_number', label: 'Engine Number', type: 'text', required: true, unique: true },
    { key: 'vin', label: 'Chassis / VIN', type: 'text', required: true, unique: true },
    { key: 'registration_number', label: 'Registration Number', type: 'text', unique: true },
    { key: 'registration_book_number', label: 'Registration Book #', type: 'text' },
    { key: 'token_tax_expiry', label: 'Token / Tax Expiry', type: 'date' },
  ],
  'Property': [
    { key: 'property_type', label: 'Property Type', type: 'select', options: PROPERTY_TYPES, required: true },
    { key: 'society_project', label: 'Society / Project', type: 'text', required: true },
    { key: 'plot_house_number', label: 'Plot / House #', type: 'text', required: true },
    { key: 'street_block', label: 'Street / Block', type: 'text' },
    { key: 'city', label: 'City', type: 'text', required: true },
    { key: 'size', label: 'Size', type: 'text' },
    { key: 'property_registration_number', label: 'Registration / Registry #', type: 'text', required: true, unique: true },
    { key: 'file_number', label: 'File #', type: 'text' },
  ],
};

export const CATEGORY_COMMON_FIELDS = [
  { key: 'purchase_price', label: 'Purchase Price (PKR)', type: 'number', required: true },
  { key: 'sale_price', label: 'Sale Price (PKR)', type: 'number', required: true },
  { key: 'purchase_date', label: 'Purchase Date', type: 'date' },
  { key: 'supplier', label: 'Supplier', type: 'text' },
  { key: 'stock_status', label: 'Stock Status', type: 'select', options: STOCK_STATUS },
  { key: 'description', label: 'Description / Notes', type: 'textarea' },
];

export function primaryIdentifier(item) {
  const spec = (CATEGORY_FIELDS[item.product_type] || []).find((f) => f.unique && item[f.key]);
  return spec ? `${spec.label}: ${item[spec.key]}` : (item.product_id || '-');
}
